import React from 'react';
import './InstallPromptModal.css';

const COPY = {
  native: {
    title: 'Play again faster next time',
    body: 'Add Cringe Quest to your Home Screen so Jack Ass is one tap away.',
    primary: 'Add to Home Screen',
    secondary: 'Maybe Later',
  },
  ios: {
    title: 'Add Cringe Quest to your iPhone',
    body: 'Tap the Share button, then choose Add to Home Screen.',
    primary: 'I Added It',
    secondary: 'Maybe Later',
  },
  android: {
    title: 'Add Cringe Quest to your phone',
    body: 'Open the Chrome menu, then choose Add to Home screen or Install app.',
    primary: 'I Added It',
    secondary: 'Maybe Later',
  },
};

const InstallPromptModal = ({
  isOpen = false,
  variant = 'native',
  onInstallClick,
  onDismiss,
  onMarkInstalled,
}) => {
  if (!isOpen || !COPY[variant]) {
    return null;
  }

  const content = COPY[variant];
  const isInstructionVariant = variant === 'ios' || variant === 'android';

  const handlePrimaryClick = () => {
    if (isInstructionVariant) {
      onMarkInstalled?.();
      return;
    }

    onInstallClick?.();
  };

  return (
    <div
      className="cq-install-prompt-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cq-install-prompt-title"
    >
      <div
        className="cq-install-prompt-modal"
        style={{
          '--cq-install-bg': `url(${process.env.PUBLIC_URL}/images/bg_artdeco_pattern_maroon.png)`,
          '--cq-install-brass': `url(${process.env.PUBLIC_URL}/images/brass_plate_button.png)`,
        }}
      >
        <button
          type="button"
          className="cq-install-prompt-close"
          aria-label="Close add to Home Screen prompt"
          onClick={onDismiss}
        >
          X
        </button>

        <p className="cq-install-prompt-kicker">Next Round</p>
        <h2 id="cq-install-prompt-title" className="cq-install-prompt-title">
          {content.title}
        </h2>
        <p className="cq-install-prompt-body">{content.body}</p>

        {variant === 'ios' && (
          <ol className="cq-install-prompt-steps">
            <li>Tap the Share icon in Safari.</li>
            <li>Choose Add to Home Screen.</li>
            <li>Tap Add.</li>
          </ol>
        )}

        {variant === 'android' && (
          <ol className="cq-install-prompt-steps">
            <li>Tap the three-dot menu in Chrome.</li>
            <li>Choose Add to Home screen or Install app.</li>
            <li>Confirm Add or Install.</li>
          </ol>
        )}

        <div className="cq-install-prompt-actions">
          <button
            type="button"
            className="cq-install-prompt-primary"
            onClick={handlePrimaryClick}
          >
            <span className="cq-install-prompt-primary__plate" aria-hidden="true" />
            <span className="cq-install-prompt-primary__label">{content.primary}</span>
          </button>
          <button
            type="button"
            className="cq-install-prompt-secondary"
            onClick={onDismiss}
          >
            {content.secondary}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPromptModal;
